import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["options", "xhr"];
import Raven from 'raven-js';
import HttpClient from 'flow-doctor-lib/constants/HttpClient';
import { registerQuery } from 'data-fetching-client';
const EMPTY_OR_ILS_FILTER_BRANCH = {
  filterBranchOperator: 'OR',
  filterBranchType: 'OR',
  filterBranches: [],
  filters: []
};
const EMPTY_AND_ILS_FILTER_BRANCH = {
  filterBranchOperator: 'AND',
  filterBranchType: 'AND',
  filterBranches: [],
  filters: []
};
const populateFiltersFromResponse = (filterBranch, response) => {
  const filtersToAdd = response.results.map(_ => _.filter).filter(_ => !!_);
  let filterBranchesToAdd = response.results.map(_ => _.filterBranch).filter(_ => !!_);

  // Consolidate all filters into a single filterBranch, and append that to the end
  filterBranchesToAdd = filtersToAdd.length > 0 ? filterBranchesToAdd.concat([Object.assign({}, EMPTY_AND_ILS_FILTER_BRANCH, {
    filters: filtersToAdd
  })]) : filterBranchesToAdd;
  return Object.assign({}, filterBranch, {
    filterBranches: [...filterBranch.filterBranches, ...filterBranchesToAdd]
  });
};
export const BATCH_CONVERT_CLS_FILTERS_TO_ILS = registerQuery({
  fieldName: 'batchClsToIls',
  args: ['portalId', 'filters'],
  fetcher({
    portalId,
    filters
  }) {
    // First batch the filter AND groups so we can match them up with the response
    const batchedAndFilters = filters.map(filter => filter.ands);

    // Make all requests async
    const requestPromises = batchedAndFilters.map(batchedFilters => HttpClient.post(`automationplatform/v1/cls-to-ils/batch/convert`, {
      data: batchedFilters,
      query: {
        portalId
      }
    }));
    return Promise.allSettled(requestPromises).then(settledPromises => settledPromises.reduce((acc, promise) => {
      if (promise.status === 'rejected') {
        // Strip recursive properties from the error object so we don't blow up sentry
        const _promise$reason = promise.reason,
          withoutOptionsXhr = _objectWithoutPropertiesLoose(_promise$reason, _excluded);
        console.error(promise.reason);
        Raven.captureException(promise.reason, {
          extra: withoutOptionsXhr
        });
        throw promise.reason;
      }
      return populateFiltersFromResponse(acc, promise.value);
    }, EMPTY_OR_ILS_FILTER_BRANCH));
  }
});